import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import store from '@store';
import { APP_CONFIG } from '@constants';
import { CUSTOM_MESSAGES } from '@veriables';
import { getObjectValue } from '@utility/utills';
import { safeJsonParse } from '@utility/helperFunction';
import {
  deleteItm,
  sendChecks,
  setSeat,
  setIsFromCheckList,
  addChecks,
  updateCartAfterNote,
} from '@reducers/orders';
import { updateChecksAfterResponse, moveChecks } from '@reducers/storeChecks';
import { setErrorPopUp } from '@reducers/notification';
import CustomEventEmitter from '@utility/customEventEmitter';
import uuidv4 from 'uuid/v4';


const getOrderSendModeType = type => {
  switch (type) {
    case 'toGo':
      return 1;
    case 'doNotMake':
      return 2;
    case 'onTheFly':
      return 4;
    case 'runner':
      return 4;
    default:
      return 0;
  }
};

const activateGameCards = (data, menuItemsHashTable) => {
  let value = false;
  let items = data?.orders[0].items;
  items.forEach(i => {
    if (i.pending) {
      if (
        menuItemsHashTable[safeJsonParse(i.orderJson, {})?.menuItemId].cardType == 1
      ) {
        value = true;
      }
    }
  });
  return value;
};

const isGiftCards = data => {
  let giftCards = data?.cards || [];
  return giftCards.some(el => el.status === 0 && !el.void);
};

const getSeatNumber = (seatId, seat) => {
  const value = seat?.seats?.filter(item => item.id === seatId);
  return value?.[0]?.number;
};

const availableInItem = (elem, itemsArray) => {
  const array = itemsArray.map(item => {
    if (item?.seats?.[0]?.seatId === elem.id) {
      return elem.id;
    }
  });
  return array.includes(elem.id);
};

const availableInCart = (elem, arr) => {
  const newArr = arr?.filter(item => item?.seatIds?.[0] === elem.id);
  return newArr?.length !== 0;
};

const checkItemValidity = (items, menuItemsHashTable, coursesHashTable) => {
  for (const item of items) {
    if (item?.brandCourseId) {
      if (
        coursesHashTable &&
        coursesHashTable[item?.brandCourseId] &&
        coursesHashTable[item?.brandCourseId]?.beverageRequirement
      ) {
        return true;
      }
    } else {
      const value = menuItemsHashTable[item.menuItemId];
      if (
        value?.brandCourseId &&
        coursesHashTable?.[value.brandCourseId]?.beverageRequirement
      ) {
        return true;
      }
    }
  }
  return false;
};

const getInvalidateSeatsNumbers = (seat, menuItemsHashTable, coursesHashTable) => {
  const mapItemsWithSeatIds = new Map();
  const invalidSeatsId = [];
  const invalidSeatNumbers = [];

  const seats = getObjectValue(
    () => safeJsonParse(window.sessionStorage.getItem('seat')),
    []
  );
  const emptySeats = seat.seats.filter(
    elem =>
      elem.open &&
      !availableInCart(elem, seats.PendingItems) &&
      !availableInItem(elem, seats.Items)
  );

  seat?.items?.forEach(sentItem => {
    const seatId = sentItem?.seats?.[0]?.seatId;
    const items = mapItemsWithSeatIds.get(seatId);
    if (items) {
      mapItemsWithSeatIds.set(seatId, [...items, sentItem]);
    } else {
      mapItemsWithSeatIds.set(seatId, [sentItem]);
    }
  });

  seats?.PendingItems?.forEach(item => {
    const seatId = item?.seatIds?.[0];
    const items = mapItemsWithSeatIds.get(seatId);
    if (items) {
      mapItemsWithSeatIds.set(seatId, [...items, item]);
    } else {
      mapItemsWithSeatIds.set(seatId, [item]);
    }
  });

  mapItemsWithSeatIds.forEach((itemsArray, seatId) => {
    const s = seat.seats.filter(item => item.id === seatId);
    if (s[0]?.open) {
      if (!checkItemValidity(itemsArray, menuItemsHashTable, coursesHashTable)) {
        invalidSeatsId.push(seatId);
      }
    }
  });

  emptySeats.forEach(emptySeat => {
    invalidSeatNumbers.push(emptySeat.number);
  });

  invalidSeatsId.forEach(id => {
    invalidSeatNumbers.unshift(getSeatNumber(id, seat));
  });
  return invalidSeatNumbers.sort((a, b) => a - b);
};


const getLinkedMenuItemsId = (selectedItems, orderItems, type, orderId, menusList, menuItemsHashTable) => {
  const menuList = [];
  selectedItems.forEach(item => {
    let printOrderTypeId = null;
    let groupItem = [];
    menusList.forEach(menu => {
      if (groupItem.length === 0)
        groupItem = menu.screens.filter(ele => ele.id == item.menuScreenId);
    });
    if (
      groupItem[0]?.orderTypePrintRouting === true ||
      menuItemsHashTable[item.menuItemId]?.orderTypePrintRouting === true
    ) {
      printOrderTypeId = orderId;
    }
    const modJson = safeJsonParse(item.modifierJson, {});
    if (!modJson.hasLinkedMenuItem) {
      menuList.push({
        checkOrderItemId: item.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    } else {
      (modJson.modifiers || []).forEach(e => {
        const linkedIndex = orderItems.findIndex(
          d =>
            d.pending &&
            safeJsonParse(d.orderJson, {}).menuItemId === e.modifierId &&
            safeJsonParse(safeJsonParse(d.orderJson, {}).modifierJson, {})
              .uniqueIdForLinkedItem === modJson.uniqueIdForLinkedItem
        );
        if (linkedIndex > -1) {
          menuList.push({
            checkOrderItemId: orderItems[linkedIndex].id,
            orderSendMode: getOrderSendModeType(type),
            printRoutingOrderTypeId: printOrderTypeId,
          });
        }
      });
      menuList.push({
        checkOrderItemId: item.id,
        orderSendMode: getOrderSendModeType(type),
        printRoutingOrderTypeId: printOrderTypeId,
      });
    }
  });
  return menuList;
};

export const useFooterActions = seat => {
  const navigate = useNavigate();

  const deleteAll = useCallback(() => {
    if (!seat?.id) return;
    const { oauth } = store.getState();
    const deviceInfo = oauth.deviceInformation;
    const userInfo = oauth.loggedInUserData;
    const datatosend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: userInfo.id,
      checkHeaderId: seat.id,
      employeeCard: userInfo.employeeCard,
      items: seat.orders[0].items
        .filter(e => e.pending)
        .map(item => ({ checkOrderItemId: item.id })),
    };
    store
      .dispatch(deleteItm(datatosend))
      .then(val => {
        store.dispatch(updateChecksAfterResponse(val));
      })
      .catch(err => {
        store.dispatch(setErrorPopUp({ res: err.message }));
      });
  }, [seat]);

  const sendAll = useCallback(
    (type, orderId, selectedItems) => {
      if (!seat?.id) return;
      const { oauth, orders } = store.getState();
      const deviceInfo = oauth.deviceInformation;
      const userInfo = oauth.loggedInUserData;
      const auth = oauth.authInfo;
      const menusList = orders.menusList;
      const menuItemsHashTable = orders.menuItemsHashTable;
      const coursesHashTable = orders.coursesHashTable;
      const isAll = !selectedItems;
      const data = seat;

      if (
        deviceInfo?.deviceGroup?.serverAppSettings
          ?.enforceBeverageRequirementBySeat === true &&
        isAll === true
      ) {
        const invalidSeatNumbers = getInvalidateSeatsNumbers(
          data,
          menuItemsHashTable,
          coursesHashTable
        );
        if (invalidSeatNumbers.length) {
          store.dispatch(
            setErrorPopUp({
              res:
                CUSTOM_MESSAGES().BEVERAGE_REQUIREMENT_ERROR +
                invalidSeatNumbers.join(', '),
            })
          );
          return;
        }
        const datatosend = {
          storeId: deviceInfo.storeId,
          deviceId: deviceInfo.deviceId,
          employeeId: userInfo.id,
          checkHeaderId: data.id,
          employeeCard: userInfo.employeeCard,
          items: selectedItems
            ? getLinkedMenuItemsId(selectedItems, data.orders[0]?.items, type, orderId, menusList, menuItemsHashTable)
            : data.orders[0]?.items
              .filter(e => e.pending)
              .map(item => {
                let printOrderTypeId = null;
                let groupItem = [];
                menusList.forEach(menu => {
                  if (groupItem.length === 0)
                    groupItem = menu.screens.filter(
                      ele => ele.id == item.menuScreenId
                    );
                });
                if (
                  (groupItem.length > 0 &&
                    groupItem[0]?.orderTypePrintRouting) ||
                  menuItemsHashTable[item.menuItemId]?.orderTypePrintRouting ===
                  true
                ) {
                  printOrderTypeId = orderId;
                }
                return {
                  checkOrderItemId: item.id,
                  orderSendMode: getOrderSendModeType(type),
                  printRoutingOrderTypeId: printOrderTypeId,
                };
              }),
        };
        store
          .dispatch(sendChecks(datatosend))
          .then(res => {
            store.dispatch(updateChecksAfterResponse(res));
            store.dispatch(setSeat(res));
            if (
              res.sourceType === 0 &&
              auth.gamingSystemConfig &&
              activateGameCards(res, menuItemsHashTable)
            ) {
              navigate(`${APP_CONFIG.BASE_URL}/gamecard/${data?.id}`, {
                replace: true,
              });
            } else if (isGiftCards(res) && isAll) {
              store.dispatch(setIsFromCheckList(true));
              navigate(`${APP_CONFIG.BASE_URL}/giftcard/${data?.id}`, {
                replace: true,
              });
            }
          })
          .catch(err => {
            store.dispatch(setErrorPopUp({ res: err.message }));
          });
        return;
      }

      const datatosend = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        checkHeaderId: data.id,
        employeeCard: userInfo.employeeCard,
        items: selectedItems
          ? getLinkedMenuItemsId(selectedItems, data.orders[0]?.items, type, orderId, menusList, menuItemsHashTable)
          : data.orders[0].items
            .filter(e => e.pending)
            .map(item => {
              let printOrderTypeId = null;
              let ItemData = data?.PendingItems?.find(
                itemVal => itemVal.id === item.id
              );
              let groupItem = [];
              menusList.forEach(menu => {
                if (groupItem.length === 0)
                  groupItem = menu.screens.filter(
                    it => it.id == ItemData?.menuScreenId
                  );
              });
              if (
                groupItem[0]?.orderTypePrintRouting === true ||
                menuItemsHashTable[ItemData?.menuItemId]?.orderTypePrintRouting ===
                true
              ) {
                printOrderTypeId = orderId;
              }
              return {
                checkOrderItemId: item.id,
                orderSendMode: getOrderSendModeType(type),
                printRoutingOrderTypeId: printOrderTypeId,
              };
            }),
      };
      store
        .dispatch(sendChecks(datatosend))
        .then(res => {
          store.dispatch(updateChecksAfterResponse(res));
          store.dispatch(setSeat(res));
          if (
            res.sourceType === 0 &&
            auth?.gamingSystemConfig &&
            activateGameCards(res, menuItemsHashTable)
          ) {
            navigate(`${APP_CONFIG.BASE_URL}/gamecard/${data?.id}`, {
              replace: true,
            });
          } else if (isGiftCards(res) && isAll) {
            store.dispatch(setIsFromCheckList(true));
            navigate(`${APP_CONFIG.BASE_URL}/giftcard/${data?.id}`, {
              replace: true,
            });
          }
        })
        .catch(err => {
          store.dispatch(setErrorPopUp({ res: err.message }));
        });
    },
    [seat, navigate]
  );

  const sentMove = useCallback(
    (selectedItems, seatIds) => {
      if (!seat?.id || !selectedItems?.length) return;
      const { oauth } = store.getState();
      const deviceInfo = oauth.deviceInformation;
      const userInfo = oauth.loggedInUserData;

      const checkItemSeats = selectedItems
        .filter(i => !i.isServiceCharge && !i.isDiscount && !i.discountId && !i.serviceChargeId)
        .map(item => ({ checkItemId: item.id }));
      const checkDiscountSeats = selectedItems
        .filter(i => i.isDiscount || i.discountId || (i.discountName && !i.menuItemId))
        .map(item => {
          const discountId = item.checkDiscountId || (typeof item.id === 'number' ? item.id : Number(String(item.id).replace(/^discount-/, '')));
          return { checkDiscountId: isNaN(discountId) ? item.id : discountId };
        });
      const checkServiceChargeSeats = selectedItems
        .filter(i => i.isServiceCharge || i.serviceChargeId || (i.serviceChargeName && !i.menuItemId))
        .map(item => {
          const serviceChargeId = item.checkServiceChargeId || (typeof item.id === 'number' ? item.id : Number(String(item.id).replace(/^serviceCharge-/, '')));
          return { checkServiceChargeId: isNaN(serviceChargeId) ? item.id : serviceChargeId };
        });

      const datatosend = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        employeeCard: userInfo.employeeCard,
        seatIds: seatIds.includes('table') ? [] : seatIds,
        checkItemSeats,
        checkDiscountSeats,
        checkServiceChargeSeats,
      };
      return store
        .dispatch(moveChecks(datatosend))
        .then(res => {
          store.dispatch(updateChecksAfterResponse(res));
          store.dispatch(setSeat(res));
          return true;
        })
        .catch(err => {
          store.dispatch(setErrorPopUp({ res: err.message }));
        });
    },
    [seat?.id]
  );

  const unsentMove = useCallback(
    (selectedItems, seatIds) => {
      if (!seat?.id || !selectedItems?.length) return;
      const { oauth } = store.getState();
      const deviceInfo = oauth.deviceInformation;
      const userInfo = oauth.loggedInUserData;
      const finalSeatIds = seatIds.includes('table') ? [] : seatIds;
      const orderItems = getObjectValue(() => seat.orders[0].items, []);
      const mappedItems = orderItems.reduce((a, v) => {
        if (selectedItems.some(d => d.id === v.id)) {
          const item = safeJsonParse(v.orderJson, {});
          const modifierJson = safeJsonParse(item.modifierJson, {});
          a.push({
            ...item,
            seatIds: finalSeatIds,
            modifierJson: JSON.stringify({ ...modifierJson, seatIds: finalSeatIds }),
            checkOrderItemId: v.id,
          });
        }
        return a;
      }, []);
      const dataToSend = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        employeeCard: userInfo.employeeCard,
        items: mappedItems,
        orderJson: JSON.stringify(mappedItems),
        latitude: '0',
        longitude: '0',
        geoLocation: '0',
      };
      store
        .dispatch(addChecks(dataToSend, 'update'))
        .then(res => {
          store.dispatch(updateChecksAfterResponse(res));
        })
        .catch(err => {
          store.dispatch(setErrorPopUp({ res: err.message }));
        });
    },
    [seat]
  );

  const repeat = useCallback(
    (selectedItems, isUnsent) => {
      if (!seat?.id || !selectedItems?.length) return;
      const { oauth } = store.getState();
      const deviceInfo = oauth.deviceInformation;
      const userInfo = oauth.loggedInUserData;
      const orderItems = getObjectValue(() => seat.orders[0].items, []);

      const hasLinked = selectedItems.some(
        e => e.modifierJson && safeJsonParse(e.modifierJson, {}).hasLinkedMenuItem
      );

      let comboItems = [];

      if (hasLinked) {
        const changedUniqueId = uuidv4();
        const linkedRepeatItems = orderItems.filter(c =>
          selectedItems.some(
            d =>
              safeJsonParse(d.modifierJson, {}).uniqueIdForLinkedItem ===
              safeJsonParse(safeJsonParse(c.orderJson, {}).modifierJson, {})
                .uniqueIdForLinkedItem
          )
        );
        linkedRepeatItems.forEach(v => {
          const matchItem = selectedItems.find(d =>
            isUnsent ? d.id === v.id : d.id === v.checkItemId
          );
          if (!matchItem) return;
          const item = safeJsonParse(v.orderJson, {});
          const modifierJson = safeJsonParse(item.modifierJson, {});
          modifierJson.seatIds = item.seatIds;
          const internalId = new Date().getTime() + Math.random();
          const finalSeatIds =
            v.seats?.map(el => el.seatId) || item.seatIds || [];
          comboItems.push({
            ...item,
            internalId,
            price: matchItem.price,
            seatIds: finalSeatIds,
            modifierJson: JSON.stringify({
              ...modifierJson,
              seatIds: finalSeatIds,
              internalId,
              uniqueIdForLinkedItem: changedUniqueId,
            }),
            checkOrderItemId: isUnsent ? v.id : v.checkItemId,
            pending: true,
            menuTypeId: modifierJson?.menuTypeId,
            id: isUnsent ? v.id : v.checkItemId,
          });
        });
      } else {
        orderItems.forEach(v => {
          const matchItem = selectedItems.find(d =>
            isUnsent ? d.id === v.id : d.id === v.checkItemId
          );
          if (!matchItem) return;
          const item = safeJsonParse(v.orderJson, {});
          const modifierJson = safeJsonParse(item.modifierJson, {});
          modifierJson.seatIds = item.seatIds;
          const internalId = new Date().getTime() + Math.random();
          const finalSeatIds =
            v.seats?.map(el => el.seatId) || item.seatIds || [];
          comboItems.push({
            ...item,
            internalId,
            price: matchItem.price,
            seatIds: finalSeatIds,
            modifierJson: JSON.stringify({
              ...modifierJson,
              seatIds: finalSeatIds,
              internalId,
            }),
            checkOrderItemId: isUnsent ? v.id : v.checkItemId,
            pending: true,
            menuTypeId: modifierJson?.menuTypeId,
            id: isUnsent ? v.id : v.checkItemId,
          });
        });
      }

      if (!comboItems.length) return;
      const dataToSend = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        employeeCard: userInfo.employeeCard,
        items: comboItems,
        orderJson: JSON.stringify(comboItems),
        latitude: '0',
        longitude: '0',
        geoLocation: '0',
      };
      return store
        .dispatch(addChecks(dataToSend, 'add'))
        .then(res => {
          store.dispatch(updateChecksAfterResponse(res));
          store.dispatch(setSeat(res));
          return res;
        })
        .catch(err => {
          store.dispatch(setErrorPopUp({ res: err.message }));
          throw err;
        });
    },
    [seat]
  );

  const refill = useCallback(
    (selectedItems) => {
      if (!seat?.id || !selectedItems?.length) return;
      const { oauth, orders } = store.getState();
      const deviceInfo = oauth.deviceInformation;
      const userInfo = oauth.loggedInUserData;
      const menuItemsHashTable = orders.menuItemsHashTable;
      const orderItems = getObjectValue(() => seat.orders[0].items, []);

      const comboItems = [];
      selectedItems.forEach(item => {
        const seatIds = item?.seats?.map(el => el.seatId);
        const refillMenuItemId = menuItemsHashTable[item.menuItemId]?.refillMenuItemId;
        const refillMenuItem = refillMenuItemId ? menuItemsHashTable[refillMenuItemId] : null;

        if (item.hasLinkedMenuItem || item.combo) {
          const uniqueId = orderItems.find(e => e.checkItemId === item.id)
            ?.uniqueIdForLinkedItem;
          const changedUniqueId = uuidv4();
          orderItems.forEach(v => {
            if (v.itemType === 'D') return;
            const vOrderJson = safeJsonParse(v.orderJson, {});
            const vModJson = safeJsonParse(vOrderJson.modifierJson, {});
            if (
              vModJson.uniqueIdForLinkedItem &&
              (vModJson.uniqueIdForLinkedItem === item.uniqueIdForLinkedItem ||
                vModJson.uniqueIdForLinkedItem === uniqueId)
            ) {
              const randomNumber = Math.trunc(Math.random() * 10000);
              const newInternalId = +`${new Date().getTime()}${randomNumber}`;
              const modifierJson = { ...vModJson };
              if (vOrderJson.refill) {
                modifierJson.menuItemId = item?.menuItemId;
                modifierJson.menuItemName = item?.menuItemName;
              }
              if (refillMenuItemId) {
                modifierJson.menuItemId = refillMenuItemId;
                modifierJson.menuItemName = refillMenuItem?.name;
              }
              const finalSeatIds = (seatIds?.length > 0 && seatIds) || vOrderJson.seatIds || [];
              comboItems.push({
                ...vOrderJson,
                internalId: newInternalId,
                uniqueIdForLinkedItem: changedUniqueId,
                seatIds: finalSeatIds,
                modifierJson: JSON.stringify({
                  ...modifierJson,
                  internalId: newInternalId,
                  uniqueIdForLinkedItem: changedUniqueId,
                  seatIds: finalSeatIds,
                }),
                modifiers: !item.isLinked ? [] : vOrderJson.modifiers,
                refill: true,
              });
            }
          });
        } else {
          const cartItem = orderItems.find(
            e => e.itemType !== 'D' && e.checkItemId === item.id
          );
          if (!cartItem) return;
          const randomNumber = Math.trunc(Math.random() * 10000);
          const newInternalId = +`${new Date().getTime()}${randomNumber}`;
          const cartOrderJson = safeJsonParse(cartItem.orderJson, {});
          const modifierJson = safeJsonParse(cartOrderJson.modifierJson, {});
          if (cartOrderJson.refill) {
            modifierJson.menuItemId = item?.menuItemId;
            modifierJson.menuItemName = item?.menuItemName;
          }
          if (refillMenuItemId) {
            modifierJson.menuItemId = refillMenuItemId;
            modifierJson.menuItemName = refillMenuItem?.name;
          }
          const finalSeatIds = (seatIds?.length > 0 && seatIds) || cartOrderJson.seatIds || [];
          comboItems.push({
            ...cartOrderJson,
            internalId: newInternalId,
            seatIds: finalSeatIds,
            modifierJson: JSON.stringify({
              ...modifierJson,
              internalId: newInternalId,
              seatIds: finalSeatIds,
            }),
            refill: true,
          });
        }
      });

      if (!comboItems.length) return;
      const dataToSend = {
        storeId: deviceInfo.storeId,
        deviceId: deviceInfo.deviceId,
        employeeId: userInfo.id,
        checkHeaderId: seat.id,
        employeeCard: userInfo.employeeCard,
        items: comboItems,
        orderJson: JSON.stringify(comboItems),
        latitude: '0',
        longitude: '0',
        geoLocation: '0',
      };
      return store
        .dispatch(addChecks(dataToSend, 'add'))
        .then(res => {
          store.dispatch(updateChecksAfterResponse(res));
          store.dispatch(setSeat(res));
          const cartItems = getObjectValue(() => res?.orders[0]?.items, [])
            .filter(e => e.pending)
            .map(it => {
              const modifierJson = safeJsonParse(
                safeJsonParse(it.orderJson, {})?.modifierJson,
                {}
              );
              const refillItem = safeJsonParse(it.orderJson, {});
              return {
                ...modifierJson,
                modifierJson: JSON.stringify(modifierJson),
                id: it.id,
                pending: true,
                refill: refillItem?.refill,
              };
            });
          CustomEventEmitter.dispatchEvent('getCartItems', cartItems);
          store.dispatch(updateCartAfterNote(cartItems));
          return res;
        })
        .catch(err => {
          store.dispatch(setErrorPopUp({ res: err.message }));
          throw err;
        });
    },
    [seat]
  );

  return { deleteAll, sendAll, sentMove, unsentMove, repeat, refill };
};
